import '../../App.less';
import { Layout, Row, Col,ConfigProvider,Table,Modal,Transfer,Menu,Input, Space, AutoComplete,notification, Select,Form, Checkbox,Divider,Upload } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from '../Cabezal.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,CheckOutlined,UploadOutlined,  UserOutlined,HomeOutlined,MinusCircleOutlined,PlusOutlined,EditOutlined,TeamOutlined,FileTextOutlined,ReadOutlined,DownloadOutlined,MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined,LogoutOutlined,BarChartOutlined } from '@ant-design/icons';
import axios from "axios";
import countries from '../../static/json/countries.json'
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import Navbar from '../components/NavBar'


class ConcList extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      plays:[],
      fileList: [],
      authors:[],
      edit:false,
      countryCode:'',
      countryName:'',
      countrychanged:'',
      plays_report:[],
      filteredInfo:[],
      makeGenreReport:false,
      reportGenre:'Novela',
      reportCountry:null,
      makeCountryReport:false,
      genre:{},
      create:false,
      name:'',
      showAddPlays:false,
      unassignedPlays:[],
      assignedPlays:[],
      saveAddPlays:false,

    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/casa/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }
 
  getAuthors(auth){
    var authors = []
    for (var i in auth){
     authors.push({id:i,
       name: auth[i]["nombre_completo"]} )
    }
   return authors

 }
 
 getAuthorsStr(auth){
   var authors = []
   for (var i in auth){
    authors.push( auth[i]["nombre_completo"])
    
   }
  return authors

}

getCountryName(country){
  for(var c in  countries["countries"]){
    if (countries["countries"][c]["code"]==country)
      return countries["countries"][c]["name_es"]
  }
  return "No name"
}
  async componentDidUpdate(prev){
    if(prev.juryType != this.props.juryType){
      this.componentWillMount()
    }
  }

  async componentWillMount() {
    const response_jury= await fetch('https://back.premiocasa.cult.cu/api/casa/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_jury = await response_jury.json();
    if(json_jury['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    const response_plays= await fetch('https://back.premiocasa.cult.cu/api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const response_genr= await fetch('https://back.premiocasa.cult.cu/api/casa/genero/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
    const json_genre = await response_genr.json();
    this.genre = {}
    var data_jury = []
    this.json = {}
    var data_play = []
    
    console.log("J",json_jury)
    console.log("O",json_plays)
   
    const Moment = require('moment');

    json_genre.map(g=>{this.genre[g.id] = g})
    console.log("GENERO",this.genre )
    json_plays.map(play=>
      { 
        var date= new Moment(play.fecha_registro).format('DD-MM-YYYY')
        var year = date.split('-')[2]
        play.author = this.getAuthors(play.conc)
        play.authorStr = this.getAuthorsStr(play.conc).join(", ")
        play.date = date 
        play.code=year+'_'+play.genero+'_'+play.id
        play.genero_nombre=this.genre[play.genero].nombre
        
        this.json[play.id] = play
      })
    var data = []
    for(var i in json_jury){
      var item = json_jury[i];

      if(this.props.juryType == this.genre[item.genero].nombre || this.props.juryType == "all" ){
      var authorStr = this.getAuthorsStr(item.conc).join(", ")
      var plays_objects =  item.obras.map(p=>this.json[p])
      console.log("JURY PLAYS", plays_objects)
      data_jury.push(
          { 
              id : item.id,
              full_name:item.nombre_completo,
              name : item.usuario,
              username_id: item.usuario_id,
              category:item.genero,
              categoryName:this.genre[item.genero].nombre ,
              plays:item.obras,
              plays_objects: plays_objects,
              country: this.getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,
              email: item.email,
              // date:'',
              edit:''
          });
      }
      
    };



    
    var data = []

    this.names = new Set();
    this.emails = new Set();
    this.countries = new Set();
    for(var i in this.json){
      var item = this.json[i];
      console.log("PPOPOPASODASD",item)
      this.names.add(item.username)
      this.emails.add(item.email)
      this.countries.add(this.getCountryName(item.pais))
      if((this.props.juryType == this.genre[item.genero].nombre || this.props.juryType == "all")  && item.califica )
        data.push(
            { 
                key : item.id.toString(),
                authorStr:item.authorStr,
                title : item.titulo,
                pseudo:item.pseudonimo,
                category: item.genero,
            });
    };

    console.log("DATA",data )
    this.setState({ plays: data_jury, plays_report:data_play, filteredInfo: data,genre:this.genre });

    this.names = [...this.names].map((v)=>{
      return {value:v}
    })
    this.emails =[...this.emails].map((v)=>{
      return {value:v}
    })
    this.countries = [...this.countries].map((v)=>{
      return {value:v}
    })

  }

  onChangeSelect(value){
    this.setState({countrychanged:value})
  }
 

  handleTableChange = (pagination, filters, sorter, extra) => {
    console.log('Various parameters', extra.currentDataSource);
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }

  getCountryCode(country){
    for(var c in  countries["countries"]){
      if (countries["countries"][c]["name_es"]==country)
        return countries["countries"][c]["code"]
    }
    return "No code"
  }
  getAutocomplete = (dataIndex) =>{
    console.log(this.codes)
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "name" ) {
        return this.names
    } 

    else if (dataIndex== "email"){
      return this.emails
    }
    else{
      console.log("AUTOCOMPLETE",this.countries)
      return this.countries
    }
  }
  onClickArticle = record  => {
    console.log("Record",record)
        this.setState({showArticle:true,record:record});
    var unassigned = []
    for(var i in this.json){
      if(!record.plays.includes(i)){
        unassigned.push(i)
      }
    }

    this.setState({ assignedPlays:[...record.plays]})
  };

  async onClickSave(){

    console.log("PPPPP")
    console.log(this.state.categoryChanged)
    var options = {
       method: "patch",
       credentials: "same-origin",
       headers: {
         "Authorization": localStorage.getItem("Authorization") ,
         "Accept": "application/json",
         "Content-Type": "application/json"},
      
     }
     // id : i,
     // title : item.titulo,
     // author: author ,
     // date:date,
     // pseudo: item.pseudonimo,
     // code:item.code,
     // // date:'',
     // category:item.genero.nombre,
     // pdf:item.pdf
     // console.log(document.getElementById("inputPseudo").value)

     
    //  <p><UserOutlined /> Nombre:<Input defaultValue= {this.state.record.name} id="nameInput" /> </p>
    //  <p><MailOutlined /> Email:<Input defaultValue= {this.state.record.email} id="emailInput" /></p>
    //  <p><PhoneOutlined /> Teléfono: <Input defaultValue= {this.state.record.phone} id="emailInput" /> </p>
    //  <p><GlobalOutlined /> País: <Select style={{width:'80%'}} >
    //            {countries["countries"].map((obj)=>{
    //              return <Option value={obj["code"]}>{obj["name_es"]}</Option>
    //          })}
                 
    //            </Select> </p>
    //  <p><EnvironmentOutlined /> Dirección: <Input defaultValue= {this.state.record.address} id="addressInput" /></p>
    //  <p><IdcardOutlined /> Ficha: <Input defaultValue= {this.state.record.ficha} id="fichaInput" /></p>
    var userChanged = {
      username: document.getElementById("nameInput").value,
      email: document.getElementById("emailInput").value,
    }
    if(document.getElementById("password").value.trim() != "")
      userChanged["password"] = document.getElementById("password").value

    await axios.patch(`https://back.premiocasa.cult.cu/api/casa/usuario/${this.state.record.username_id}/`, userChanged, options)
    .then(
      (response) => {
        console.log(response);
        if(response.status === 200)
           console.log(response);
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         }
      },
      (error) => {
       //  const message = await error.json()
       //  var errors = []
        
       //  console.log(message)
       //  errors.join(", ")
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       })
      }
    ).catch((err) => 
     console.log(err)
    
    )
    var juryChanged={
      nombre_completo: document.getElementById("fullNameInput").value,

      telefono: document.getElementById("phoneInput").value,
      direcc_personal:document.getElementById("addressInput").value,
      ficha:document.getElementById("fichaInput").value,
      pais:this.state.countrychanged?this.getCountryCode(this.state.countrychanged):this.getCountryCode(this.state.record.country),
      obras:this.state.saveAddPlays? this.state.assignedPlays.map(p=> parseInt(p)): this.state.record.plays
    }
     
     await axios.patch(`https://back.premiocasa.cult.cu/api/casa/jurado/${this.state.record.id}/`, juryChanged, options)
     .then(
       (response) => {
         console.log(response);
         if(response.status === 200)
           window.location.reload()
          else{
            notification.error({
            message:'Error',
            description:'Hubo un error, por favor revise los datos',
          });
          }
       },
       (error) => {
        //  const message = await error.json()
        //  var errors = []
         
        //  console.log(message)
        //  errors.join(", ")
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        })
       }
     ).catch((err) => 
      console.log(err)
     
     )
     
   }

  onClickEditPlay= record  => {
    console.log("Record",this.state.filteredInfo)
    var assigned = record.plays.map(p=>p.toString())
    console.log("Assigned",assigned)
    
        this.setState({edit:true,record:record, assignedPlays:[...assigned], newJuryCategory:record.category});
  };
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
          assignedPlays:[],
          unassignedPlays:[]
        });
  };

  hidePlaysModal = () => {
    this.setState({
      showPlays: false,
     
    });
};

  hideEdit = () => {
    
    this.setState({
      edit: false,
      record: null,
      newJuryCategory:1
    });
};
showAdd = ()=>{
  console.log("Before SHOWADD", this.state.showAddPlays)
  this.setState({showAddPlays:true},()=>console.log("AFTER SHOWADD", this.state.showAddPlays))
}
getColumnPlaysSearchProps = (dataIndex,nombre) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <AutoComplete 
      style={{ width: 188, marginBottom: 8, display: 'block' }}
      options={this.getAutocomplete(dataIndex)}
      filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
      onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
      value={selectedKeys[0]}

      >
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Buscar ${nombre}`}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        />
      </AutoComplete>
      <Space>
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Buscar
        </Button>
        <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
          Resetear
        </Button>

      </Space>

    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    dataIndex!="author"?
     (record[dataIndex]
      ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
      : ''):
      (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
 ,
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select(), 100);
    }
  },
  render: (text,record,index) =>

     this.state.searchedColumn === dataIndex ? (
       dataIndex !="author"?
      (<div style={{fontSize:'large' }}>
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ''}
      />
      </div>):
      record[dataIndex].map(auth=>
      (<div style={{fontSize:'large' }}>
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={auth['name'] ? auth['name'] : ''}
      />
      </div>))
    ) : (
      <div style={{fontSize:'large' }}>
        {(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> )
        || (  <div>{text}</div>)  }
      </div>
    ),
});
  getColumnSearchProps = (dataIndex,name) => dataIndex!='edit' && ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => ( dataIndex!='edit' &&
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
             <Input
               ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Buscar ${name}`}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() => this.handleReset(clearFilters)} size="small" type="reset" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>
          </div>
        ),
        filterIcon: filtered =>dataIndex!='edit' && <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
          if (visible && dataIndex!= 'edit') {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
          this.state.searchedColumn === dataIndex ? (
            <div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>
          ) : (
            <div  style={{fontSize:'large' }}>
            {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||
            <a onClick = {()=>this.onClickArticle(record)} >  {text} </a>}
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        console.log("HANDLE")
        console.log(selectedKeys)
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
      };
      createJury =() => {
        this.setState({ create:true, assignedPlays:[] });
      };
      closeCreateJury =() => {
        this.setState({ create:false });
      };
      onClickSavePlays=()=>{
          this.setState({showAddPlays:false,saveAddPlays:true})
      }
      onClickCancelPlays=()=>{
        this.setState({showAddPlays:false,saveAddPlays:false})
      }
      showPlays=()=>{
        this.setState({showPlays:true})
      }

      handleTransferChange = (newTargetKeys, direction, moveKeys) => {
        console.log("Transfer",newTargetKeys, direction, moveKeys)
        direction=='left'? this.setState({ assignedPlays:[...newTargetKeys] }): this.setState({ assignedPlays:this.state.assignedPlays.concat(moveKeys) })
      };
      handleSubmit = (form)=>{
        const data= new FormData()
        this.setState({isBusy:true},()=>axios.post('https://back.premiocasa.cult.cu/api/casa/register/', data).then((res) => {
        if (res.status == 200){
          this.setState({isBusy:false})
          Modal.success({
            content: 'Gracias por registrarse en el concurso',
            onOk:()=> window.open("/casa/registro","_self")
          });
         
        } ;
      }).catch((err) => {
        this.setState({isBusy:false})
        // var m = readError(err)
        console.log("AQUI")
        notification.error({
          message:'Error',
          description:err.response.data.non_field_errors[0],
        });
        
      }))
      }
      async logout(){
        await fetch('https://back.premiocasa.cult.cu/api/logout',{
          method: "post",
          credentials: "same-origin",
          headers: {
            "Authorization": localStorage.getItem("Authorization") ,
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        }).then(result=>{
          if(result.status == 200){
            var userId = localStorage.getItem("UserId")
        const data_log= new FormData()
        data_log.append('usuario',userId)
        data_log.append('accion',"Salida del sistema")
      
        axios.post('https://back.premiocasa.cult.cu/api/casa/logs/', data_log)
            localStorage.clear()
            window.location.reload(); 
          }
          else{
            notification.error({
          message:'Error',
          description:'Hubo un error, por favor intente más tarde',
        })}
        })
      }
      
      

  render() {
    console.log("Jury type", this.props.juryType)
    const generateReport =()=> generatePDFConc(this.state.plays)
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays_report,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays_report,"read")
    
    const downloadCurrentReport =()=> generatePDFConc(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFConc(this.state.filteredInfo,"read")
    
    const downloadConcReport =()=> generatePDFConc(this.state.plays,"save")
    const readConcReport =()=> generatePDFConc(this.state.plays,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais '] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
  const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais '] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

  const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"save")
  const readPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"read")


  const onClickGenreReport=()=>{
    this.setState({makeGenreReport:true})
  }
  const onClosekGenreReport=()=>{
    this.setState({makeGenreReport:false})
  }
  const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}


  const onClickCountryReport=()=>{
    this.setState({makeCountryReport:true})
  }
  const onClosekCountryReport=()=>{
    this.setState({makeCountryReport:false})
  }
  const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}
    
  const centerStyle = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignElements:'center',
  };
      const { Header, Footer, Content } = Layout;
      const Moment = require('moment');
      const columnsPlays =  [
                
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
          dataIndex: 'code',
          key: 'code',
          // sorter: (a, b) => a.code.localeCompare(b.code),
          width:'8%',
          // sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnPlaysSearchProps('code','número'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
          dataIndex: 'titulo',
          key: 'titulo',
          sorter: (a, b) => a.title.localeCompare(b.title),
          // sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnPlaysSearchProps('title','título'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
          dataIndex: 'pseudonimo',
          key: 'pseudonimo',
          // sorter: (a, b) => a.title.localeCompare(b.title),
          // sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnPlaysSearchProps('pseudo','seudónimo'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Autor(es)</div>,
          dataIndex: 'author',
          key: 'author',
          // sorter: (a, b) => a.author.localeCompare(b.author),
          // sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnPlaysSearchProps('author','autor'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Género</div>,
          dataIndex: 'genero_nombre',
          key: 'genero_nombre',
          width:'8%',
          // sorter:(a,b) => a.category.localeCompare(b.category),
          // sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnPlaysSearchProps('category','género'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
          dataIndex: 'date',
          key: 'date',
          width:'8%',
          // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnPlaysSearchProps('date','fecha'),
          responsive: ['sm'] 
        },
        {
          title: <div style={{fontWeight:'bold', fontSize:'large' }}>Obra</div>,
          sorter: (a, b) => a.name.localeCompare(b.name),
          sortDirections:['ascend', 'descend', 'ascend'],
          ...this.getColumnPlaysSearchProps('name','nombre'),
          render: (record) => (
            <React.Fragment>
              <a onClick = {()=>this.onClickArticle(record)} >   
              <b style={{fontSize:'large'}}>{record.title}</b>
              </a>

              <br />
              <b>Código:</b>{record.code}
              <br />
              <b>Seudónimo:</b>{record.pseudonimo}
              <br />
              <b>Autor(es):</b><ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> 
              <b>Género:</b>{record.genero_nombre}
              <br />
              <b>Fecha:</b>{record.date}
            </React.Fragment>
          ),
          responsive: ['xs'] 
        },
        


      
      
  ];
      const columns = [
               

                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large' }}>Nombre</div>,
                    sorter: (a, b) => a.name.localeCompare(b.name),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('full_name','full_name'),
                    render: (record) => (
                      <React.Fragment>
                      <a onClick = {()=>this.onClickArticle(record)} >   
                      <b style={{fontSize:'large'}}>{record.full_name}</b>
                      </a>
                      <br />
                      <b>Usuario:</b>{record.name}
                      <br />
                      <b>Género:</b>{record.categoryName}
                    </React.Fragment>
                    ),
                    responsive: ['xs'] 
                  },
                  // {
                  //   title: <div style={{fontWeight:'bold', fontSize:'large'}}>País</div>,
                  //   dataIndex: 'country',
                  //   key: 'country',
                  //   width:'10%',
                  //   sorter:(a,b) => a.country.localeCompare(b.country),
                  //   sortDirections:['ascend', 'descend', 'ascend'],
                  //   ...this.getColumnSearchProps('country','país'),
                  //   responsive: ['sm'] 
                  // },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Editar</div>,
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'20%',
                    render: (text,record) =>(
                                <div  style={{fontSize:'large' }}>
                                <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                                </div>
                    ),
                    // sorter:(a,b) => new Moment(a.date).format('YYYYMMDD') - new Moment(b.date).format('YYYYMMDD'),
                    sortDirections:['ascend', 'descend', 'ascend'],
                  },
            ];

            const content=(
              <div>
              <Button key="back" onClick={this.hideModal}> <ReadOutlined />Read</Button>
              <Button key="back" onClick={this.hideModal}> <DownloadOutlined />Download</Button>
        
              </div>
        
            );
            const formItemLayout = {
              labelCol: {
                xs: {
                  span: 24,
                },
                sm: {
                  span: 8,
                },
              },
              wrapperCol: {
                xs: {
                  span: 24,
                },
                sm: {
                  span: 16,
                },
              },
            };
            const { SubMenu } = Menu;
            const validateMessages =  {
      
              required: '${label} es requerido!',
              types: {
                email: '${label} no es un email válido!',
                number: '${label} no es un número válido!',
              },
              number: {
                range: '${label} must be between ${min} and ${max}',
              },
            
              
            }

            const genreOptions = this.state.props == 'poetry'
            const customRequest = (form) => {
      
             
            
               const data= new FormData()
               
         
         
               form['telefono'] = '+' + form['telefono']
               
               for ( var key in form ) {
                 if(key =='autores'){
                   data.append(key,JSON.stringify( form[key]));
                   // addAuthors(data,form[key],'autores')
                 }
                 else{
                   data.append(key, form[key]);
                 }
             }
         
             data.append('premio',1)

             var obras =this.state.saveAddPlays? this.state.assignedPlays.map(p=> data.append('obras',parseInt(p))): []
             
             form['pais'] =  this.getCountryCode(form['pais'])
             // if(form['pdf'].type != 'application/pdf')
           //   for (var value of data.values()) {
           //     console.log(value);
           //  }
         
               this.setState({isBusy:true},()=>axios.post('https://back.premiocasa.cult.cu/api/casa/jurado/register',data, {
                    headers: {
                    "Authorization": localStorage.getItem("Authorization") ,
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                    }
                }).then((res) => {
                 if (res.status == 200){
                   this.setState({isBusy:false,assignedPlays:[]})
                   Modal.success({
                     content: 'Jurado registrado',
                     onOk:()=> window.location.reload(false)
                   });
                  
                 } ;
               }).catch((err) => {
                console.log(err.response.data)
                 var errorsMessage = err.response.data.join(';')
                 this.setState({isBusy:false})
                 // var m = readError(err)
                 console.log("AQUI")
                 console.log(err.response)
                 notification.error({
                   message:'Error',
                   description:errorsMessage ,
                 });
                 
               }))
               
         
           }
           const menu = (
            <Menu style={{height:'140'}} mode="inline">
            <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
            <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/admin"> Inicio</NavLink>
            </Menu.Item>
            <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
            <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/admin_plays_list"> Obras</NavLink>
            </Menu.Item>
            <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
            <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/casa/admin_conc_list'> Concursantes  </NavLink>
            </Menu.Item>
           
            <SubMenu key="jury" icon={<TeamOutlined  style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Jurado">
          <Menu.Item>
          <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado'> Todo  </NavLink>
          </Menu.Item>
          <Menu.Item>
          <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado_poe'> Poesía  </NavLink>
          </Menu.Item>

          <Menu.Item style={{ fontWeight:'bold'}} >
          <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado_nov'> Novela  </NavLink>
          </Menu.Item>

          <Menu.Item style={{ fontWeight:'bold'}} >
          <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/casa/admin_jurado_ens'> Ensayo  </NavLink>
          </Menu.Item>
       </SubMenu>
            <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
            <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold'}}> Cerrar sesión </a>
            </Menu.Item>
            
            </Menu>
          )
            
    return (

      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
<Layout style={{backgroundColor:'white'}}>
<Row>
            <Col><NavLink to="/casa"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          

          </Row>
          
          <Row>
            <Col span={24}>
            <Navbar menu={menu}/>

            
            </Col>
          </Row>
            <Content>
              <Row  align="middle" justify="center">
                <Col span={24}>
                  <Table 
                  columns={columns}
                  bordered 
                  dataSource= {this.state.plays}
                  pagination={{ position: ["bottomCenter"],}}
                  tableLayout='auto'
                  style={{ whiteSpace: 'normal'}}
                  size="small"
                  footer={()=> <Button onClick={this.createJury}style={{alignItems:'end', width:'100%'}}>Añadir jurado</Button>}
                  />
                </Col>
              </Row>
                
         
                {
                    this.state.showArticle && 
                    <Modal 
                    closable = {false}
                        title={ this.state.record.title}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                        ]}
                        >
                          <p><UserOutlined /> Nombre completo: {this.state.record.full_name}</p>
                        <p><UserOutlined /> Usuario: {this.state.record.name}</p>
                        <p><MailOutlined /> Email: {this.state.record.email}</p>
                        <p><PhoneOutlined /> Teléfono: {this.state.record.phone}</p>
                        <p><GlobalOutlined /> País: {this.state.record.country}</p>
                        <p><EnvironmentOutlined /> Dirección: {this.state.record.address}</p>
                        <p><IdcardOutlined /> Ficha: {this.state.record.ficha}</p>
                        <p> <Button key="back" onClick={this.showPlays}>
                              Ver obras
                              </Button></p>
              
                    
                    </Modal>
                    }

{
                    this.state.showPlays && 
                    <Modal 
                    width='90%'
                      closable = {false}
                        title={ this.state.record.name + " - Obras"}
                        visible={this.state.showPlays} 
                        footer={[
                            <Button key="back" onClick={this.hidePlaysModal}>
                            Regresar
                            </Button>,
                        ]}
                        >
                            <Table
                            
                            bordered
                            columns={columnsPlays}
                            dataSource= {this.state.record.plays_objects}
                            pagination={{ position: ["bottomCenter"],}} 
                            tableLayout='auto'
                            size='small'
                            style={{ whiteSpace: 'normal'}}
                          />
                    </Modal>
                    }
                    { this.state.showAddPlays && <Modal 
                          closable = {false}
                          title={ "Añadir obras al jurado"}
                          visible={this.state.showAddPlays} 
                          
                          footer={[
                            <Button key="save" onClick={this.onClickSavePlays}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.onClickCancelPlays}>
                              Cancelar
                              </Button>,
                               
                          ]}
                          >
                         <Row align="middle" justify="center" >
                           <Col span={24}>
                           <Transfer 
                           onChange={this.handleTransferChange}
                           dataSource={this.state.filteredInfo}
                           targetKeys={this.state.assignedPlays}
                           listStyle={{
                            width: 150,
                            height: 200,
                          }}
                          
                          render={item => {return item.title +": "+ item.authorStr}}
                        titles={['Sin asignar', 'Asignadas']}
                        >

                        </Transfer>
                           </Col>
                         </Row>
                       

                       
  
                      </Modal>}
                    { this.state.edit && <Modal 
                          closable = {false}
                          title={ this.state.record.title}
                          visible={this.state.edit} 
                          footer={[
                            <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.hideEdit}>
                              Regresar
                              </Button>,
                               
                          ]}
                          >
                          <p><UserOutlined /> Nombre completo:<Input defaultValue= {this.state.record.full_name} id="fullNameInput" /> </p>
                         <p><UserOutlined /> Usuario:<Input defaultValue= {this.state.record.name} id="nameInput" /> </p>
                        <p><MailOutlined /> Email:<Input defaultValue= {this.state.record.email} id="emailInput" /></p>
                        <p><PhoneOutlined /> Teléfono: <Input defaultValue= {this.state.record.phone} id="phoneInput" /> </p>
                        <p><GlobalOutlined /> País:<br/> <Select style={{width:'100%'}} showSearch defaultValue={this.state.record.country} onChange={(value)=>this.onChangeSelect(value)} >
                                  {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                    return <Option value={obj["name_es"]}>{obj["name_es"]}</Option>
                                })}
                                    
                                  </Select> </p>
                        <p><EnvironmentOutlined /> Dirección: <Input defaultValue= {this.state.record.address} id="addressInput" /></p>
                        <p><IdcardOutlined /> Ficha: <Input defaultValue= {this.state.record.ficha} id="fichaInput" /></p>
                        <p> <Button key="back" onClick={this.showAdd}>
                              Añadir obras
                              </Button></p>

                       
  
                      </Modal>}
                      
                      { this.state.create && 
                      
                      <Modal 
                          closable = {false}
                          title={"Añadir jurado"}
                          visible={this.state.create} 
                          onCancel={this.closeCreateJury}
                          footer={[
                              <Button key="back" onClick={this.closeCreateJury}>
                              Regresar
                              </Button>,
                          ]}
                      >
                         
                                    
                          <Form {...formItemLayout} id='regForm' name="nest-messages" onFinish={customRequest} validateMessages={validateMessages} layout = 'horizontal' initialValues={{autores: [""]}}>
                          
                          <Row  justify="center" align="middle" >
                            <Col xs={{span:24, offset:0 }}sm={{span:24, offset:0 }}>

                            <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                    <Form.Item name={['nombre_completo']} fieldKey={['first']} label="Nombre completo" rules={[{ required: true }]}>
                                      <Input style={{width:'80%'}}/>
                                    </Form.Item>
                                </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={['username']} fieldKey={['first']} label="Nombre de usuario" rules={[{ required: true }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item name={['password']} fieldKey={['first']} label="Contraseña" rules={[{ required: true }]}>
                                    <Input style={{width:'80%'}}/>
                                  </Form.Item>
                                </Col>
                              </Row>
                                          
                              <Row  justify="center" align="middle" >
                                <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                    <Form.Item  name={['pais']} label="País" fieldKey={[ 's']} rules={[{ required: true }]}>
                                      <Select style={{width:'80%'}} showSearch className="my-select">
                                        {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                          return <Option value={obj["name_es"]}>{obj["name_es"]}</Option>
                                      })}
                                        </Select>
                                    </Form.Item>
                                  </Col>
                              </Row>
                              <Row  justify="center" align="middle" >
                               <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                  <Form.Item  name={[ 'email']} label="Correo electrónico" rules={[{ type: 'email',  required: true }]}>
                                    <Input style={{width:'80%'}} />
                                  </Form.Item>
                                </Col>
                              </Row>
                                            
                                            <Row  justify="center" align="middle" >
                                        <Col xs={{span:24, offset:2}}sm={{span:24, offset:0 }}>
                                            <Form.Item  name={[ 'telefono']} label="Teléfono" rules={[{ required: true }]}>
                                                  <PhoneInput
                                                  localization={es}
                                              country={'cu'}
                                              enableSearch={true}
                                              searchPlaceholder="Buscar"
                                              value={this.state.phone}
                                              autoFocus= {true}
                                              onChange={phone => this.setState({ phone })}
                                              placeholder ={"Número de teléfono"}
                                            />
                                            </Form.Item>
                                            </Col>
                                            </Row>
                                            
                                            <Row  justify="center" align="middle" >
                                              <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                                <Form.Item name={[ 'direcc_personal']} label="Dirección postal"rules={[{ required: true }]}>
                                                  <Input style={{width:'80%'}}/>
                                                </Form.Item>
                                              </Col>
                                            </Row>
                                            
                                            <Row  justify="center" align="middle" >
                                              <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                                <Form.Item  name={[ 'ficha']} label="Ficha bio-bibliográfica"rules={[{ required: true }]}>
                                                  <Input.TextArea  placeholder='Máximo 500 caracteres' style={{width:'80%'}} />
                                                </Form.Item>

                                              </Col>
                                            </Row>
                                            
                            <Row  justify="center" align="middle" >
                        <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                            <Form.Item name={[ 'genero']} label="Género"rules={[{ required: true }]}>
                              <Select style={{width:'80%'}}>
                              {(Object.values(this.state.genre).map((obj)=>{
                                return ( <Option value={obj.id}>{obj.nombre}</Option>)  
                            })) }
                                
                              </Select>
                            </Form.Item>
                            </Col>
                            </Row>
                            
                          
                        <Row  justify="center" align="middle" >
                          <Col xs={{span:24, offset:2 }}sm={{span:16, offset:8 }}>
                                    <Button key="back" onClick={this.showAdd}>
                                          Añadir obras
                                          </Button>
                          </Col>
                        </Row>
                            
                        <Row  justify="center" align="middle" >
                          <Col xs={{span:24, offset:2 }}sm={{span:16, offset:8 }}>
                            <Form.Item  >
                                <Button icon={<CheckOutlined/>} type="primary" htmlType="submit" size='small' >
                                  Registrar
                                </Button>
                            </Form.Item>
                          </Col>
                        </Row>
                                            
                            </Col>

                          </Row>

                        
                    


                      
                          </Form>
                       
  
                      </Modal>}

           
            </Content>
          </Layout>
         
        </ConfigProvider>
    </div>
    <Footer style={{backgroundColor:'#00b2e7', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#00b2e7',  marginBottom:'0px', bottom:'0px'}}>
          <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/casa/admin_bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
          <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto: premiocasa@casa.cult.cu">premiocasa@casa.cult.cu</a></div></Col>
          <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
          <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
          <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/casa/admin_terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
          
        </Row>
        </Footer>
    </div>

    );
  }
}
export default ConcList;


